"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItemDataCy = getItemDataCy;
exports.getSectionDataCy = getSectionDataCy;
exports.useMultiComboboxController = useMultiComboboxController;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _downshift = require("downshift");
function getItemDataCy(dataCy, action, item) {
  var _item$textValue;
  return "".concat(dataCy, "-").concat(action, "-").concat((_item$textValue = item.textValue) === null || _item$textValue === void 0 ? void 0 : _item$textValue.replace(' ', '_'));
}
function getSectionDataCy(dataCy, item) {
  var _item$section, _item$section$name;
  return "".concat(dataCy, "-group-").concat(((_item$section = item.section) === null || _item$section === void 0 ? void 0 : (_item$section$name = _item$section.name) === null || _item$section$name === void 0 ? void 0 : _item$section$name.replace(' ', '_')) || 'no-category');
}
function getFlattenedItems(items) {
  var flattenedItems = [];
  var lastSectionKey;
  items.sort(function (a, b) {
    var _a$section, _a$section$key, _b$section;
    return ((_a$section = a.section) === null || _a$section === void 0 ? void 0 : (_a$section$key = _a$section.key) === null || _a$section$key === void 0 ? void 0 : _a$section$key.toString().localeCompare(((_b$section = b.section) === null || _b$section === void 0 ? void 0 : _b$section.key) || '')) || 0;
  }).forEach(function (item) {
    if (item.section) {
      var sectionKey = item.section.key;
      if (sectionKey !== lastSectionKey) {
        flattenedItems.push({
          section: {
            key: sectionKey,
            name: item.section.name
          }
        });
        lastSectionKey = sectionKey;
      }
      flattenedItems.push(_objectSpread({}, item, {
        section: undefined,
        sectionKey: item.section.key
      }));
    } else {
      flattenedItems.push(_objectSpread({}, item, {
        section: undefined,
        sectionKey: undefined
      }));
    }
  });
  return flattenedItems;
}
function useMultiComboboxController(items, selectedKeys, setSelectedKeys) {
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var _React$useState3 = React.useState(getFlattenedItems(items).filter(function (item) {
      return selectedKeys.includes(item.key || '');
    })),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    selectedItems = _React$useState4[0],
    setSelectedItems = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    expandedSectionKeys = _React$useState6[0],
    setExpandedSectionKeys = _React$useState6[1];
  var hasSections = React.useMemo(function () {
    return items.some(function (item) {
      return item.section;
    });
  }, [items]);
  var toggleSection = function toggleSection(currentSectionKey, event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    setExpandedSectionKeys(expandedSectionKeys.includes(currentSectionKey) ? expandedSectionKeys.filter(function (name) {
      return name !== currentSectionKey;
    }) : [].concat(_toConsumableArray(expandedSectionKeys), [currentSectionKey]));
  };
  function isItemVisible(item) {
    var _item$section2;
    if (!hasSections) {
      return true;
    }
    if ((_item$section2 = item.section) !== null && _item$section2 !== void 0 && _item$section2.key) {
      return shouldRenderSectionHeader(item);
    } else {
      return isItemSectionExpanded(item);
    }
  }
  function shouldRenderSectionHeader(item) {
    var _item$section3;
    return !!((_item$section3 = item.section) !== null && _item$section3 !== void 0 && _item$section3.name) && menuItemsIncludingSections.some(function (i) {
      var _item$section4;
      return i.sectionKey === ((_item$section4 = item.section) === null || _item$section4 === void 0 ? void 0 : _item$section4.key);
    });
  }
  function elementHasFocus(index) {
    return highlightedIndex === index;
  }
  var flattenedItems = React.useMemo(function () {
    return getFlattenedItems(items);
  }, [items]);
  var isItemSectionExpanded = (0, _react.useCallback)(function (item) {
    var _item$section5;
    if (!hasSections) {
      return true;
    }
    if ((_item$section5 = item.section) !== null && _item$section5 !== void 0 && _item$section5.key) {
      var _item$section6;
      // a section is expanded if manually expanded or filter is active and section has items matching the filter
      return expandedSectionKeys.includes(((_item$section6 = item.section) === null || _item$section6 === void 0 ? void 0 : _item$section6.key) || '') || !!inputValue && flattenedItems.some(function (i) {
        var _item$section7;
        return i.sectionKey === ((_item$section7 = item.section) === null || _item$section7 === void 0 ? void 0 : _item$section7.key);
      });
    } else {
      // an item is expanded if manually expanded or filter is active
      return expandedSectionKeys.includes(item.sectionKey || '') || !!inputValue;
    }
  }, [hasSections, expandedSectionKeys, inputValue, flattenedItems]);
  var menuItemsIncludingSections = React.useMemo(function () {
    var lowerCasedInputValue = inputValue.toLowerCase();
    return flattenedItems.filter(function (item) {
      var _item$section8, _item$textValue2;
      return ((_item$section8 = item.section) === null || _item$section8 === void 0 ? void 0 : _item$section8.name) || !selectedItems.includes(item) && ((_item$textValue2 = item.textValue) === null || _item$textValue2 === void 0 ? void 0 : _item$textValue2.toLowerCase().startsWith(lowerCasedInputValue));
    });
  }, [inputValue, flattenedItems, selectedItems]);
  (0, _react.useEffect)(function () {
    var selectedItems = flattenedItems.filter(function (item) {
      return item.key && selectedKeys.includes(item.key);
    }).filter(Boolean);
    if (selectedItems) setSelectedItems(selectedItems);
  }, [selectedKeys, flattenedItems]);
  function doSetSelectedItems(newSelectedItems) {
    setSelectedItems(newSelectedItems);
    setSelectedKeys(newSelectedItems.map(function (item) {
      return item.key;
    }).filter(Boolean));
  }
  function onSelectedItemsChange(_ref) {
    var newSelectedItems = _ref.selectedItems,
      type = _ref.type;
    switch (type) {
      case _downshift.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
      case _downshift.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
      case _downshift.useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
        doSetSelectedItems(newSelectedItems || []);
        break;
      case _downshift.useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
        doSetSelectedItems(newSelectedItems || []);
        openMenu();
        break;
      default:
        break;
    }
  }
  function getNextVisibleItemIndex(highlightedIndex, goingDown) {
    var nextItemIndex = highlightedIndex;
    while (!isItemVisible(menuItemsIncludingSections[nextItemIndex])) {
      nextItemIndex = goingDown ? nextItemIndex + 1 : nextItemIndex - 1;
      if (nextItemIndex >= menuItemsIncludingSections.length) {
        nextItemIndex = 0;
      }
      if (nextItemIndex < 0) {
        nextItemIndex = menuItemsIncludingSections.length - 1;
      }
    }
    return nextItemIndex;
  }
  function stateReducer(_state, actionAndChanges) {
    var _changes$selectedItem;
    var changes = actionAndChanges.changes,
      type = actionAndChanges.type;
    switch (type) {
      case _downshift.useCombobox.stateChangeTypes.InputBlur:
        setInputValue('');
      // fallthrough
      case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
      case _downshift.useCombobox.stateChangeTypes.ItemClick:
        if ((_changes$selectedItem = changes.selectedItem) !== null && _changes$selectedItem !== void 0 && _changes$selectedItem.section) {
          toggleSection(changes.selectedItem.section.key);
          return _objectSpread({}, changes, {
            isOpen: true,
            highlightedIndex: menuItemsIncludingSections.indexOf(changes.selectedItem)
          });
        }
        return _objectSpread({}, changes, changes.selectedItem ? {
          isOpen: true,
          highlightedIndex: menuItemsIncludingSections.indexOf(changes.selectedItem)
        } : null);
      case _downshift.useCombobox.stateChangeTypes.InputKeyDownArrowDown:
      case _downshift.useCombobox.stateChangeTypes.InputKeyDownArrowUp:
        return _objectSpread({}, changes, {
          highlightedIndex: changes.highlightedIndex ? getNextVisibleItemIndex(changes.highlightedIndex, type === _downshift.useCombobox.stateChangeTypes.InputKeyDownArrowDown) : changes.highlightedIndex
        });
      case _downshift.useCombobox.stateChangeTypes.ToggleButtonClick:
        return _objectSpread({}, changes);
      default:
        return changes;
    }
  }
  function onStateChange(_ref2) {
    var newInputValue = _ref2.inputValue,
      type = _ref2.type,
      newSelectedItem = _ref2.selectedItem;
    switch (type) {
      case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
      case _downshift.useCombobox.stateChangeTypes.ItemClick:
        if (newSelectedItem) {
          doSetSelectedItems([].concat(_toConsumableArray(selectedItems), [newSelectedItem]));
          setInputValue('');
        }
        break;
      case _downshift.useCombobox.stateChangeTypes.InputChange:
        setInputValue(newInputValue || '');
        break;
      default:
        break;
    }
  }
  var _ref4 = (0, _downshift.useCombobox)({
      items: menuItemsIncludingSections,
      inputValue: inputValue,
      selectedItem: null,
      stateReducer: stateReducer,
      onStateChange: onStateChange
    }),
    isOpen = _ref4.isOpen,
    openMenu = _ref4.openMenu,
    getToggleButtonProps = _ref4.getToggleButtonProps,
    getLabelProps = _ref4.getLabelProps,
    getMenuProps = _ref4.getMenuProps,
    getInputProps = _ref4.getInputProps,
    highlightedIndex = _ref4.highlightedIndex,
    getItemPropsOriginal = _ref4.getItemProps;
  /*
  	patch some accessibility issues with downshift
  	 'aria-selected' should not be set on a list item
  	 'role' should be set to 'listitem' even though the element is a li in the DOM
  	 this is according to a11y guidelines
  	 */
  var getItemProps = function getItemProps(props) {
    var itemProps = getItemPropsOriginal(props);
    return _objectSpread({}, itemProps, {
      'aria-selected': undefined,
      role: 'listitem'
    });
  };
  var _ref5 = (0, _downshift.useMultipleSelection)({
      selectedItems: selectedItems,
      onStateChange: onSelectedItemsChange
    }),
    getSelectedItemProps = _ref5.getSelectedItemProps,
    getDropdownProps = _ref5.getDropdownProps,
    removeSelectedItem = _ref5.removeSelectedItem;
  var toggleButtonProps = getToggleButtonProps();
  var inputProps = getInputProps(getDropdownProps({
    preventKeyAction: isOpen
  }));
  var getHeaderProps = function getHeaderProps(_ref3) {
    var item = _ref3.item,
      index = _ref3.index;
    return _objectSpread({}, getItemProps({
      item: item,
      index: index
    }), {
      onClick: function onClick(event) {
        var _item$section9;
        return toggleSection(((_item$section9 = item.section) === null || _item$section9 === void 0 ? void 0 : _item$section9.key) || '', event);
      },
      isFocused: elementHasFocus(index),
      item: item,
      sectionVisible: isItemSectionExpanded(item)
    });
  };
  return {
    menuItems: menuItemsIncludingSections,
    inputValue: inputValue,
    setInputValue: setInputValue,
    selectedItems: selectedItems,
    setSelectedItems: setSelectedItems,
    isItemSectionExpanded: isItemSectionExpanded,
    shouldRenderSectionHeader: shouldRenderSectionHeader,
    elementHasFocus: elementHasFocus,
    // from useCombobox
    isOpen: isOpen,
    toggleButtonProps: toggleButtonProps,
    inputProps: inputProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    getHeaderProps: getHeaderProps,
    // from useMultipleSelection
    getSelectedItemProps: getSelectedItemProps,
    removeSelectedItem: removeSelectedItem,
    // for testing
    toggleSection: toggleSection,
    onStateChange: onStateChange,
    expandedSectionKeys: expandedSectionKeys
  };
}